import { useQuery } from '@tanstack/react-query'
import type { UserHeadResponse } from '~/domains/users/types'
import type { AddressResponse } from '~/types/global'
import { fetchApiWithToken, type WithHydraPagination } from '../utils'

export interface AgencyResponse {
  id: number
  name: string
  address?: AddressResponse
  users?: Array<UserHeadResponse>
  email?: string
  phone?: string
  registration_number?: string
}

export const useAgency = (agencyId: number | null | undefined) =>
  useQuery<AgencyResponse, Error>({
    queryKey: ['agency', agencyId],
    queryFn: () =>
      fetchApiWithToken({
        method: 'get',
        url: `/v1/agencies/${agencyId}`
      }),
    enabled: agencyId !== null && agencyId !== undefined,
    staleTime: 1800_000,
    refetchOnWindowFocus: false
  })

export const useAgenciesList = (listingContext?: string, enabled = true) =>
  useQuery<AgencyResponse[], Error>({
    queryKey: ['agencies', 'list', listingContext],
    queryFn: async () => {
      const queryParams = new URLSearchParams()
      queryParams.append('order[name]', 'asc')
      queryParams.append('itemsPerPage', '100')
      if (listingContext) {
        queryParams.append('listingContext', listingContext)
      }
      const response = await fetchApiWithToken<
        WithHydraPagination<AgencyResponse>
      >({
        method: 'get',
        url: `/v1/agencies?${queryParams.toString()}`,
        useLDJson: true
      })
      return response['hydra:member']
    },
    enabled,
    staleTime: 300_000,
    refetchOnWindowFocus: false
  })
